var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{style:({ background: _vm.$vuetify.theme.themes.dark.background })},[_c('v-main',[_c('router-view',{staticClass:"global-router"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }